export default __webpack_public_path__ + "static/media/img_fee_35.e3887533.svg";